var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgAudit = function SvgAudit(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15.5,
    cy: 9.8,
    r: 0.94
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16,0A16,16,0,1,0,32,16,16,16,0,0,0,16,0ZM14.56,25.45H8.89A1.89,1.89,0,0,1,7,23.56V10.33A1.89,1.89,0,0,1,8.89,8.44h3.95a2.82,2.82,0,0,1,5.32,0h3.95A1.89,1.89,0,0,1,24,10.33v4.73H22.11V10.33H20.22v.95a1.89,1.89,0,0,1-1.89,1.89H12.67a1.89,1.89,0,0,1-1.89-1.89v-.95H8.89V23.56h5.67ZM24.7,18.6l-5.22,5.23a.94.94,0,0,1-1.33,0L15.27,21a1,1,0,0,1,0-1.42,1,1,0,0,1,1.41,0l2.14,2.13,4.47-4.49A1,1,0,1,1,24.7,18.6Z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgAudit);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "audit.57497d513a6630b4d99ea47bea049ed2.svg";